<template>
  <div class="text-center">
    <v-divider></v-divider>
    <h6>Organização</h6>
    <div class="row mt-5">
      <div class="col-md-6 text-center mb-5">
        <img src="/assets/img/puc.png" width="50%" />
      </div>
      <div class="col-md-6 text-center mb-2">
        <img src="/assets/img/ifg.png" width="50%" />
      </div>
    </div>
    <v-divider></v-divider>

    REMOCAO DOS APOIADORES
    <h6>Apoio</h6>
    <div class="row mt-5">
      <div class="col-md-6 text-center mb-5">
        <img src="/assets/img/jirau.jpg" width="70%" />
      </div>
      <div class="col-md-6 text-center mb-2">
        <img src="/assets/img/aneel.jpg" width="70%" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <img src="/assets/img/fapeg.png" width="40%" />
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss"></style>
